import { scroller } from "../utils/scroller"

export const covidDiscountBanner = {
  starts: `Fri Dec 03 2020 00:00:01 GMT+0100 (Central European Standard Time)`,
  expires: `Fri Dec 03 2022 00:00:01 GMT+0100 (Central European Standard Time)`,
  text: `<div><b>50% off</b> for all those stuck at home due to <b>COVID-19</b></div>`,
  formatted: true,
  onClick: event => {
    if (event.target.tagName !== "A") {
      event.preventDefault()
      let target = document.getElementById("pricing-complete-masterclass")
      scroller(target, -180)
    }
  }
}